import React, { FC, useCallback, useState } from 'react';
import { ArrowIcon } from '../../../../../components';
import { CashbackCommissionReport } from '../../IBClientsCashbackModel';
import { DetailedDialog } from '../DetailedDialog';
import { DataTable, ColumnConfig } from '../../../DataTable';

interface Props {
  translation: any;
  dateFrom: Date;
  columns: ColumnConfig<CashbackCommissionReport>[];
  selectedColumns: string[];
  rows: CashbackCommissionReport[];
  onSelectColumns(columns: string[]): void;
}

export const ReportTable: FC<Props> = ({ dateFrom, columns, selectedColumns, rows, translation, onSelectColumns }) => {
  const timestamp = new Date().getTime();
  const [dialogTrigger, setDialogTrigger] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<CashbackCommissionReport>();

  const openDetailsDialog = useCallback((row: CashbackCommissionReport) => {
    setDialogTrigger(true);
    setSelectedRow(row);
  }, []);

  return (
    <>
      <DataTable columns={columns} data={rows} translation={translation} columnSelect selectedColumns={selectedColumns} onSelectColumns={onSelectColumns} emptyMessage={translation.text_6448} onRowAction={openDetailsDialog} rowActionIcon={<ArrowIcon />} />
      {selectedRow && (
        <DetailedDialog
          key={`com_dialog${timestamp}`}
          title={translation.ib_clients_cashback}
          dateFrom={dateFrom}
          data={selectedRow.subCashbackCommissionReportViewModels}
          campaignName={selectedRow.campaignName}
          open={dialogTrigger}
          translation={translation}
          handleCancel={() => setDialogTrigger(false)}
        />
      )}
    </>
  );
};
